import {
    DropDown,
    DynamicListAddButton,
    DynamicListWrapperProps,
    requiredRule,
    ValidatedDropDownList,
    ValidatedDynamicListFormComponentProps
} from '@finbeat/react-toolkit';
import { OrderStatus } from 'models/api/orderStatus';
import { useOrderStatusRolesState } from 'providers/OrderStatusRolesProvider';
import { Trans, useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';

const RoleSelectFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th>
                        <Trans i18nKey={'BackOfficeRoles'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const RoleSelectForm = ({ idx, fieldId, checkDouble }: ValidatedDynamicListFormComponentProps) => {
    const { orderStatusRoles } = useOrderStatusRolesState();
    const { t } = useTranslation();

    const rolesOptions = orderStatusRoles.map<DropDown>(({ value, text }) => ({
        id: value,
        name: value,
        label: text,
    }));

    return (
        <td>
            <ValidatedDropDownList<OrderStatus>
                name={`roles.${idx}`}
                label={t('BackOfficeRole')}
                items={rolesOptions}
                isLoading={false}
                disabled={false}
                rules={{
                    required: requiredRule,
                    validate: () => checkDouble(fieldId) ?? undefined,
                }}
            />
        </td>
    );
};

export { RoleSelectForm, RoleSelectFormWrapper };
